// extracted by mini-css-extract-plugin
export default {"title":"ViewFilesCarouselWindow_title__Afe1o"};